export default __webpack_public_path__ + "static/media/endorsement-perpani-sumbawa-barat.f8623e59.jpg";